import { render, staticRenderFns } from "./DetailPrestagesDialog.vue?vue&type=template&id=69001b23&scoped=true&"
import script from "./DetailPrestagesDialog.vue?vue&type=script&lang=js&"
export * from "./DetailPrestagesDialog.vue?vue&type=script&lang=js&"
import style0 from "./DetailPrestagesDialog.vue?vue&type=style&index=0&id=69001b23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69001b23",
  null
  
)

export default component.exports